import { render } from "@testing-library/react";
import React from "react";

export const Badge = ({ count }) => {
  console.log("Badge count: ", count);
  return (
    <>
      {count > 0 && (
        <span className="absolute -top-3 -right-2 w-5 h-5 text-white bg-red-500 text-xs rounded-full flex items-center justify-center">
          {count}
        </span>
      )}
    </>
  );
};
